import { render, staticRenderFns } from "./CoreBanner.vue?vue&type=template&id=4fb236b6&scoped=true"
import script from "./CoreBanner.vue?vue&type=script&lang=js"
export * from "./CoreBanner.vue?vue&type=script&lang=js"
import style0 from "./CoreBanner.vue?vue&type=style&index=0&id=4fb236b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.6__css-loader@7.1.2_webpa_d27aba7c9c0d786a810fc7f5935a809d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb236b6",
  null
  
)

export default component.exports